import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { FootnoteBlockNodeView } from "@/components/editor/nodeviews/FootnoteBlockNodeView";

export const FootnoteBlockNode = Node.create({
  name: "footnoteBlockNode",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      text: { default: "" },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="footnote-block-node"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "footnote-block-node" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(FootnoteBlockNodeView);
  },
});
